<template>
  <div class="row card-body">
    <div class="col-md-4">
      <div class="card card-primary">
        <div class="card-body">
          <p>
            <strong v-html="webinar.subject"></strong>
          </p>

          <p>
            <span class="glyphicon glyphicon-calendar"></span>
            <strong>Date:</strong>
            {{ webinar.start | formatDate }}
          </p>
          <p>
            <span class="glyphicon glyphicon-info-sign"></span>
            <strong>Time:</strong>
            {{ webinar.start | formatTime }} -
            {{ webinar.end | formatTime }} CST
            <br />
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-8" style="text-align: justify">
      <div class="embed-container mb-3" v-if="url">
        <iframe
          :src="url"
          frameborder="0"
          width="680"
          height="400"
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen
        ></iframe>
      </div>
      <span v-else>Preparing Recording</span>
      <h4 v-html="webinar.subject"></h4>
      <p v-html="webinar.description">{{ webinar.description }}</p>
      <p>{{ webinar.presenterDisplayName }}</p>
      <p>{{ webinar.presenterBio }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecordedWebinar",
  props: {
    webinar: Object,
    autoplay: { type: Boolean, default: false },
  },
  mounted() {},
  computed: {
    url() {
      return this.webinar.vimeoLink
        ? "https://player.vimeo.com/video/" +
            this.webinar.vimeoLink.split("vimeo.com/")[1] +
            ""
        : null;
    },
  },
};
</script>

<style>
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
  height: auto;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>